import { BookingPage } from "../pages/BookingPage";
import { AuthenticatedShellPage } from "../pages/AuthenticatedShellPage";
import { BeautyPage } from "../features/beauty/BeautyPage";
import { CapabilitiesDiagnosticPage } from "../pages/CapabilitiesDiagnosticPage";
import { CheckoutPreparingPage } from "../pages/CheckoutPreparingPage";
import { FutureVerticalPage } from "../pages/FutureVerticalPage";
import { InstitutionalPage } from "../pages/InstitutionalPage";
import { LoginPage } from "../pages/LoginPage";
import { NotFoundPage } from "../pages/NotFoundPage";
import { PricingPage } from "../pages/PricingPage";
import { ProductHomePage } from "../pages/ProductHomePage";
import { StartPage } from "../pages/StartPage";
import { reservedGoSlugs } from "../constants/routes";
import { verticals } from "../constants/verticals";
import { stripGoPrefix } from "./routing";

export function RouteSwitch({ currentPath, isGoDomain, isMainDomain }: { currentPath: string; isGoDomain: boolean; isMainDomain: boolean }) {
  if (isGoDomain) {
    const goPath = stripGoPrefix(currentPath);

    switch (goPath) {
      case "/":
        return <BeautyPage />;
      case "/pricing":
        return <PricingPage />;
      case "/start":
        return <StartPage />;
      case "/login":
        return <LoginPage />;
      case "/checkout":
        return <CheckoutPreparingPage />;
      case "/app":
        return <AuthenticatedShellPage />;
      case "/diagnostics/capabilities":
        return <CapabilitiesDiagnosticPage />;
      case "/health":
      case "/legal":
      case "/oficinas":
        return <FutureVerticalPage vertical={verticals.find((vertical) => vertical.path === goPath)} />;
      default:
        const pathSegment = goPath.startsWith("/") ? goPath.slice(1) : goPath;
        if (pathSegment && !pathSegment.includes("/") && !reservedGoSlugs.has(pathSegment)) {
          return <BookingPage tenantSlug={pathSegment} />;
        }
        return <NotFoundPage />;
    }
  }

  if (isMainDomain) {
    switch (currentPath) {
      case "/":
        return <InstitutionalPage />;
      case "/beauty":
        return <BeautyPage />;
      case "/go":
        return <ProductHomePage />;
      case "/go/pricing":
        return <PricingPage />;
      case "/go/start":
        return <StartPage />;
      case "/go/login":
        return <LoginPage />;
      case "/go/checkout":
        return <CheckoutPreparingPage />;
      case "/go/app":
        return <AuthenticatedShellPage />;
      case "/go/diagnostics/capabilities":
        return <CapabilitiesDiagnosticPage />;
      case "/health":
      case "/legal":
      case "/oficinas":
        return <FutureVerticalPage vertical={verticals.find((vertical) => vertical.path === currentPath)} />;
      default:
        if (currentPath.startsWith("/go/")) {
          const tenantSlug = currentPath.replace("/go/", "");
          if (tenantSlug && !tenantSlug.includes("/") && !reservedGoSlugs.has(tenantSlug)) {
            return <BookingPage tenantSlug={tenantSlug} />;
          }
        }
        return <NotFoundPage />;
    }
  }

  return <NotFoundPage />;
}
